import React from 'react';
import { useNavigate } from 'react-router-dom';

const CheckoutSuccessPage = () => {

    const navigate = useNavigate();

    return (
        <div className="w-2/3 p-4 mx-auto flex flex-col items-center justify-center border rounded-lg shadow-lg">
            <div className="text-center">
                <h1 className="text-2xl font-bold">Thank You!</h1>
                <p className="text-lg mt-2">Your purchase of Textractify credits was successful.</p>
            </div>

            <div className="my-6 flex flex-col items-center">
                <button className="btn btn-primary mt-4" onClick={()=>navigate('/uploads')}>
                    Return to dashboard
                </button>
            </div>
        </div>
    );
};

export default CheckoutSuccessPage;